import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import LoadingIconButton from 'components/LoadingIconButton';
import { CopyFlightButton_packageDate$key } from '__generated__/CopyFlightButton_packageDate.graphql';
import { CopyFlightButtonMutation } from '__generated__/CopyFlightButtonMutation.graphql';
import { useErrorHandler } from 'lib';

type Props = {
  packageDate: CopyFlightButton_packageDate$key;
};

const CopyFlightButton: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, flight } = useFragment(
    graphql`
      fragment CopyFlightButton_packageDate on PackageDate {
        id

        flight {
          forwardFlightNumber
          returnFlightNumber
        }
      }
    `,
    props.packageDate
  );

  const [copy, copying] = useMutation<CopyFlightButtonMutation>(graphql`
    mutation CopyFlightButtonMutation($id: ID!) {
      copyPackageDateFlight(id: $id) {
        ...PackageEditTransportFlights_package
      }
    }
  `);

  const handleCopy = useCallback(() => {
    copy({
      variables: { id },
      ...errorHandler(),
    });
  }, [copy, errorHandler, id]);

  if (!flight || (!flight.forwardFlightNumber && !flight.returnFlightNumber))
    return null;

  return (
    <Tooltip title="Pridėti kitoms datoms">
      <span>
        <LoadingIconButton loading={copying} size="small" onClick={handleCopy}>
          <ContentCopyIcon fontSize="small" />
        </LoadingIconButton>
      </span>
    </Tooltip>
  );
};

export default CopyFlightButton;
